import React, { useEffect } from "react";
import { useState } from "react";
import { trainEventRecord, trainEventRecordOverview, trainEventRecordSection } from "./TrainEventRecordPageSelector";
import { TrainEventRecordView } from "./TrainEventRecordView"
import './TrainEventRecordSection.css'
import { TrainEventRecordOverview } from "./TrainEventRecordOverview";
import { TrainEventRecordFormContents } from "./TrainEventRecordFormContents";


interface RoListProps {
    currentView: TrainEventRecordView
}

const RoListContainer = (props: RoListProps) => {

    return (
        <>
            {props.currentView === TrainEventRecordView.Overview &&
                <TrainEventRecordOverview />
            }

            {props.currentView === TrainEventRecordView.TrainEventRecord &&
                <TrainEventRecordFormContents />
            }
        </>
    );
};

interface TitleProps {
    title: string,
    titleIcon?: any
}

const TitleContainer = (props: TitleProps) => {
    return (
        <div className="te-list-title">
            {props.titleIcon}
            <div className="te-list-title-text">{props.title}</div>
        </div>
    );
}

interface TabsProps {
    tabs: TrainEventRecordView[],
    currentView: TrainEventRecordView,
    setCurrentView: any,
    visible?: boolean
}

const TabsContainer = (props: TabsProps) => {

    const getTabLabel = (view: TrainEventRecordView) => {
        let selectedPage = trainEventRecordSection;

        if (view == TrainEventRecordView.Overview) {
            selectedPage = trainEventRecordOverview;
        }

        if (view == TrainEventRecordView.TrainEventRecord) {
            selectedPage = trainEventRecord;
        }

        let title = selectedPage.label;
        if (title.startsWith("\u2003")) {
            title = title.substr(title.indexOf(" ") + 1);
        }

        return title;
    }

    useEffect(() => {
    }, [props.currentView]);

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="te-list-tabs">
            {props.tabs.map((view) =>
                <div key={view} className={`te-tab${view === props.currentView ? " te-tab-selected" : ""}`} onClick={() => props.setCurrentView(view)}>
                    {getTabLabel(view)}
                </div>
            )}
        </div>
    );
}

interface TrainEventRecordCardListProps {
    view: TrainEventRecordView[],
    title: string,
    titleIcon?: any
}

export const TrainEventRecordCardList = (props: TrainEventRecordCardListProps) => {
    const [currentView, setCurrentView] = useState(props.view[0]);

    const updateCurrentView = (view: TrainEventRecordView) => {
        setCurrentView(view);
    }

    return (
        <>
            <TitleContainer
                titleIcon={props.titleIcon}
                title={props.title} />

            <TabsContainer
                tabs={props.view}
                currentView={currentView}
                setCurrentView={updateCurrentView}
                visible={props.view.length > 1}
            />

            <RoListContainer
                currentView={currentView}
            />
        </>
    );
}